import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
const decodeHtmlEntities = str => {
  if (!str) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
};
const normalize = str => {
  return (str || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
const loadNagusiPlayersDictionary = () => {
  if (app.nagusiPlayersPromise) {
    return app.nagusiPlayersPromise;
  }
  if (app.nagusiPlayersDictionary) {
    return Promise.resolve(app.nagusiPlayersDictionary);
  }
  app.nagusiPlayersPromise = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players-dictionary'
  }).then(response => {
    var _response$data;
    app.nagusiPlayersDictionary = ((_response$data = response.data) == null ? void 0 : _response$data.attributes) || {
      photos: {},
      aliases: {}
    };
    return app.nagusiPlayersDictionary;
  }).catch(err => {
    console.error(err);
    return {
      photos: {},
      aliases: {}
    };
  });
  return app.nagusiPlayersPromise;
};
export default class Squad extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "dictionary", {
      photos: {},
      aliases: {}
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    loadNagusiPlayersDictionary().then(dict => {
      this.dictionary = dict;
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "Lineup-squad Lineup-squad--loading",
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100px'
        }
      }, m("i", {
        className: "fas fa-spinner fa-spin"
      }));
    }
    const rawData = decodeHtmlEntities(this.attrs.data || '');
    if (!rawData) return null;

    // Parse format: Grupo1=1:Jugador,2:Jugador|Grupo2=...
    const groups = rawData.split('|').map(groupStr => {
      const parts = groupStr.split('=');
      const title = parts[0] || 'Grupo';
      const playersRaw = parts.slice(1).join('=') || '';
      const players = playersRaw.split(',').filter(Boolean).map(pStr => {
        let name = '';
        let dorsal = '';
        let playerId = null;
        if (pStr.includes(':')) {
          const subParts = pStr.split(':');
          if (subParts.length >= 3 && !isNaN(Number(subParts[1]))) {
            dorsal = subParts[0] === '?' ? '' : subParts[0];
            playerId = Number(subParts[1]);
            name = subParts.slice(2).join(':');
            if (name === '?') name = '';
          } else {
            dorsal = subParts[0] === '?' ? '' : subParts[0];
            name = subParts.slice(1).join(':');
            if (name === '?') name = '';
          }
        } else {
          name = pStr === '?' ? '' : pStr;
        }
        if (!name && playerId) {
          if (this.dictionary.names_by_id && this.dictionary.names_by_id[playerId]) {
            name = this.dictionary.names_by_id[playerId];
          } else {
            const pById = app.store.getById('nagusi_players', String(playerId));
            if (pById) {
              name = pById.attribute('name');
              if (!dorsal && pById.number()) {
                dorsal = String(pById.number());
              }
            }
          }
        }
        return {
          name,
          dorsal,
          playerId
        };
      }).filter(p => p.name);
      return {
        title,
        players
      };
    }).filter(g => g.players.length > 0);
    if (groups.length === 0) return null;
    return m("div", {
      className: "Lineup-squad-container"
    }, m("div", {
      className: "Lineup-squad-grid"
    }, groups.map((group, gIdx) => m("div", {
      className: "Lineup-squad-card",
      key: gIdx
    }, m("div", {
      className: "Lineup-squad-card-header"
    }, m("h3", null, group.title), m("span", {
      className: "Lineup-squad-card-count"
    }, group.players.length, " ", group.players.length === 1 ? 'jugador' : 'jugadores')), m("div", {
      className: "Lineup-squad-card-list"
    }, group.players.map((player, pIdx) => {
      const searchNameNorm = normalize(player.name);
      let officialName = player.name;
      let aliasesStr = '';
      const lineupPlayer = app.store.all('nagusi_players').find(p => {
        const pNameNorm = normalize(p.attribute('name'));
        const pAliases = (p.attribute('aliases') || '').split(/[;,]/).map(s => normalize(s));
        return pNameNorm === searchNameNorm || pAliases.includes(searchNameNorm);
      });
      if (lineupPlayer) {
        officialName = lineupPlayer.attribute('name');
        aliasesStr = lineupPlayer.attribute('aliases') || '';
      } else {
        const localLineupPlayers = this.dictionary.aliases || {};
        const matchOfficial = Object.keys(localLineupPlayers).find(oname => {
          if (normalize(oname) === searchNameNorm) return true;
          const aliases = (localLineupPlayers[oname] || '').split(/[;,]/).map(s => normalize(s));
          return aliases.includes(searchNameNorm);
        });
        if (matchOfficial) {
          officialName = matchOfficial;
          aliasesStr = localLineupPlayers[matchOfficial] || '';
        }
      }
      const namesToTry = [player.name];
      if (officialName && !namesToTry.some(n => normalize(n) === normalize(officialName))) {
        namesToTry.push(officialName);
      }
      if (aliasesStr) {
        aliasesStr.split(/[;,]/).forEach(a => {
          const trimmedA = a.trim();
          if (trimmedA && !namesToTry.some(n => normalize(n) === normalize(trimmedA))) {
            namesToTry.push(trimmedA);
          }
        });
      }
      const localPhotos = this.dictionary.photos || {};
      let photoUrl = null;
      if (player.playerId) {
        let idMatches = false;
        if (this.dictionary.names_by_id && this.dictionary.names_by_id[player.playerId]) {
          const idOfficialName = this.dictionary.names_by_id[player.playerId];
          const idAliasesStr = this.dictionary.aliases ? this.dictionary.aliases[idOfficialName] || '' : '';
          const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
          if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
            idMatches = true;
          }
        } else {
          const pById = app.store.getById('nagusi_players', String(player.playerId));
          if (pById) {
            const idOfficialName = pById.attribute('name');
            const idAliasesStr = pById.attribute('aliases') || '';
            const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
            if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
              idMatches = true;
            }
          }
        }
        if (idMatches) {
          if (this.dictionary.photos_by_id && this.dictionary.photos_by_id[player.playerId]) {
            photoUrl = this.dictionary.photos_by_id[player.playerId];
          }
          if (!photoUrl) {
            const pById = app.store.getById('nagusi_players', String(player.playerId));
            if (pById && pById.attribute('photoUrl')) {
              photoUrl = pById.attribute('photoUrl');
            }
          }
        }
      }
      if (!photoUrl) {
        for (const n of namesToTry) {
          const nNorm = normalize(n);
          const matchKey = Object.keys(localPhotos).find(kn => normalize(kn) === nNorm);
          if (matchKey) {
            photoUrl = localPhotos[matchKey];
            break;
          }
        }
      }
      if (!photoUrl) {
        const playerFromRatings = app.store.all('nagusi_players').find(p => {
          const pNameNorm = normalize(p.attribute('name'));
          return namesToTry.some(n => normalize(n) === pNameNorm);
        });
        photoUrl = playerFromRatings ? playerFromRatings.attribute('photoUrl') : null;
      }
      return m("div", {
        className: "Lineup-squad-player",
        key: pIdx
      }, m("div", {
        className: "Lineup-squad-player-photo-wrapper"
      }, photoUrl ? m("img", {
        src: photoUrl,
        alt: player.name,
        className: "Lineup-squad-player-img"
      }) : m("div", {
        className: "Lineup-squad-player-no-photo"
      }, player.dorsal || '?')), m("div", {
        className: "Lineup-squad-player-info"
      }, player.dorsal && photoUrl && m("span", {
        className: "Lineup-squad-player-dorsal-tag"
      }, "#", player.dorsal), m("span", {
        className: "Lineup-squad-player-name"
      }, player.name)));
    }))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/Squad', Squad);